<template lang="pug">
div(
  v-if='collections'
  :class='{ "py-8 md:py-12": !overridePadding }'
  data-cnstrc-browse
  data-cnstrc-filter-name='collection_id'
  :data-cnstrc-filter-value='collectionId'
  :data-cnstrc-result-id='collections.resultId'
  :data-cnstrc-num-results='collections.numberOfResults'
)
  slot(name='title' :default-title='collections.title')
    p(v-if='collections.title' class='text-gray-darkest text-2xl font-bold leading-none pb-6 lg:text-3xl') {{ collections.title }}

  Carousel(container-class='gap-x-3' :arrow-position='arrowPosition' :arrow-width='arrowWidth')
    div(
      v-for='(result, index) in collections.results'
      :key='`${result.data?.variation_id}-${index}`'
      class='w-[275px]'
      data-cnstrc-item='Collection'
      :data-cnstrc-item-id='result.data?.productLineSlug'
      :data-cnstrc-item-name='result.value'
      :data-cnstrc-item-variation-id='result.data?.variation_id'
      :data-cnstrc-item-price='result.data?.salePrice / 100'
    )
      ProductListing(:listing='result.data' is-carousel :is-schema-on='false')
</template>

<script setup lang="ts">
const fitmentStore = useFitmentStore()
const {
  collectionId,
  overridePadding = false,
  arrowPosition = 'INLINE',
  arrowWidth = 'DEFAULT',
} = defineProps<{
  collectionId: string
  overridePadding?: boolean
  arrowPosition?: 'INLINE' | 'BOTTOM'
  arrowWidth?: 'FULL' | 'DEFAULT'
}>()

const { $constructor } = useNuxtApp()
const route = useRoute()
const constructorFitment = useConstructorFitment()

const { data: collections } = await useAsyncData(
  'collections-data',
  async () => {
    if (!collectionId) return undefined

    const filters: Record<string, any> = {}

    const fitmentFilters = constructorFitment.getFitmentAttributes()
    if (fitmentFilters) {
      filters[fitmentFilters.name] = fitmentFilters.value
    } else {
      filters.isClearance = 'False'
    }

    const params = {
      filters: filters,
      page: 1,
      resultsPerPage: 12,
    }

    const userParams = $constructor.userParams

    try {
      const data = await $constructor.client.browse.getBrowseResults('collection_id', collectionId, params, userParams)

      if (data.response?.results?.length === 0) return undefined

      return {
        title: data.response?.collection?.display_name,
        results: data.response?.results ?? [],
        resultId: data.result_id,
        numberOfResults: data.response?.total_num_results ?? 0,
      }
    } catch (error) {
      return undefined
    }
  },
  {
    watch: [fitmentStore.$state, () => route.fullPath],
  }
)
</script>
